<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em" >
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-west-three-vertical>
      <div slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>
      <template slot="center">
        <nuttrema-loader v-if="StuffToEatContent.fetching || MainStuffToEatDetails.fetching || ContentStuffToEatDetails.fetching"></nuttrema-loader>
        <stuff-to-eat-cred-content
           v-else
          :entityID="id"
          :entityType="entityType"
          :entityContentID="_get(StuffToEatContent, 'data.id')"
          :contentID="contentID"
          :contentType="contentType"
          :contentAmount="_get(StuffToEatContent, 'data.amount')"
          :contentDetails="_get(StuffToEatContent, 'data.Content')"
          :availableServing="availableServing"
          :selectedServing="selectedServing"
          :saving="StuffToEatContent.saving"
          :MainStuffToEatDetails="MainStuffToEatDetails"
          :ContentStuffToEatDetails="ContentStuffToEatDetails"
          @removeContent="onRemoveContent"
          @addServingSize="onAddServingSize"
          @submit="onFormSubmit"
          @cancel="onCancelEvent">
        </stuff-to-eat-cred-content>
      </template>
    </nuttrema-layout-west-three-vertical>

  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';
import { get } from 'lodash';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import PageProps from 'components/mixins/page-props';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';
import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import StuffToEatCredContent from './cmpt-stuff-to-eat-cred-content';

export default {
  name: 'page-stuff-to-eat-edit-content',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: true,
      default: null,
    },
    entityContentID: {
      required: true,
      default: null,
    },
    contentID: {
      required: true,
      default: null,
    },
    contentType: {
      required: true,
      default: null,
    },
    entityType: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    StuffToEatCredContent,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  computed: {
    MainStuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    ContentStuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.contentID);
    },
    StuffToEatContent() {
      return this.$store.getters.StuffToEatContent(this.entityContentID);
    },
    availableServing() {
      return get(this.StuffToEatContent, 'data.Content.EntityServingSizes.available_serving', []);
    },
    selectedServing() {
      return get(this.StuffToEatContent, 'data.Content.EntityServingSizes.selected_serving.id', null);
    },
  },
  methods: {
    ...mapActions([
      'UpdateStuffToEatContent',
      'RemoveStuffToEatContent',
      'AddStuffToEatServingSize',
    ]),
    fetchStuffToEatContent() {
      this.$store.dispatch('GetStuffToEatContent', {
        id: this.id,
        type: this.entityType,
        entityContentID: this.entityContentID,
      });
    },
    onFormSubmit(params) {
      console.log('onFormSubmit', params);
      this.UpdateStuffToEatContent(params).then(() => {
        console.log('save was successfully!');
        this.successNotification({ label: 'label.ingredient' });
        this.$store.dispatch('ReloadStuffToEatNutritionFactsWithLastCallParams', { id: this.id, type: this.entityType });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
      });
    },
    onAddServingSize(data) {
      console.log('onAddServingSize', data);
      this.AddStuffToEatServingSize(data).then(() => {
        console.log('save was successfully!');
        this.successNotification({ label: 'label.serving_size', message: 'message.default_success_added_message' });
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.serving_size', message: 'message.default_error_added_message' });
      });
    },
    onRemoveContent(data) {
      console.log('onAddServingSize', data);
      this.RemoveStuffToEatContent(data).then(() => {
        console.log('remove was successfully!');
        this.successNotification({ label: 'label.serving_size', message: 'message.default_success_delete_message' });
        this.$store.dispatch('ReloadStuffToEatNutritionFactsWithLastCallParams', { id: this.id, type: this.entityType });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification();
      });
    },
  },
  // watch: {
  //   entityContentID() {
  //     this.fetchStuffToEatContent();
  //   },
  // },
  created() {
    this.fetchStuffToEatContent();

    this.$store.dispatch('GetStuffToEatDetails', {
      id: this.contentID,
      type: this.contentType,
    });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatContent', { entityContentID: this.entityContentID });
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/contents/page-stuff-to-eat-edit-content.vue